<template>
  <v-card color="#102242" class="pb-2">
    <v-list-item class="#102242">
      <v-list-item-content>
        <v-list-item-title class="text-h6">
          {{ title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="false">
      <v-list-item-content>
        {{ markers }}
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="false">
      <v-list-item-content>
        {{ mapIcons }}
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="false">
      <v-list-item-content> -{{ mapMode }}- </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>

    <l-map
      :style="`height: ${maxContentHeight}px; z-index:0`"
      :options="{ zoomControl: false }"
      :zoom="zoom"
      :center="mapCenter"
      ref="map-obj"
    >
      <l-control-zoom position="bottomright"></l-control-zoom>
      <l-control position="topleft" class="#0D213F">
        <v-btn-toggle
          v-model="mapMode"
          class="custom-toggle-group"
          mandatory
          dense
          tile
        >
          <template v-for="(item, i) in categoryShowDef">
            <v-btn :key="'cat-' + i" :value="item.value" class="custom-toggle-btn">
              {{ item.caption }}
            </v-btn>
          </template>
        </v-btn-toggle>
      </l-control>
      <l-control position="bottomright">
        <v-btn class="custom-toggle-zoom" @click="zoomAll"> Zoom All </v-btn>
      </l-control>
      <l-control position="topright" v-if="false">
        <v-card color="#102242" class="pb-2" dense>
          <v-list-item class="#102242" dense>
            <v-list-item-content>
              <v-list-item-title class="text-title">
                {{ title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-card-text>{{ dialog }}</v-card-text>
          <v-btn @click="doClick">OK</v-btn>
        </v-card>
      </l-control>

      <l-control position="bottomleft">
        <v-card
          style="border-radius: 16px !important"
          @click="clickHandler"
          dense
        >
          <v-list dense>
            <v-list-item v-for="(item, i) in legends" :key="i">
              <div v-if="item.type === 'cluster-legend'" class="legend-cluster-icon"></div>
              <div v-else v-html="item.html"></div>
              
              <span class="ml-3 subtitle-2">{{ item.caption }}</span>
            </v-list-item>
          </v-list>
        </v-card>
      </l-control>

      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

      <v-marker-cluster :options="clusterOptions">
        <template v-for="(item, i) in markers">
          <l-marker
            :key="i"
            :lat-lng="[item.latitude, item.longitude]"
            :icon="icondiv(item)"
            v-if="item.latitude && item.longitude"
            :ref="'markerx-' + i"
          >
            <l-popup :options="{ closeButton: false, minWidth: 500 }">
              <v-btn
                @click="closeMapPopup()"
                fab
                x-small
                absolute
                top
                right
                class="ml-16 ma-10 primary"
              >
                <v-icon color="#0c203d"> mdi-close </v-icon>
              </v-btn>
              <v-card style="border-radius: 16px !important" elevation="0">
                <v-list-item two-line class="px-4">
                  <v-list-item-content class="pt-2">
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle
                      style="
                        font-size: 0.85rem;
                        color: rgba(200, 255, 255, 0.8);
                        margin-top: 2px;
                        line-height: 1.4;
                        font-weight: 400;
                      "
                      >{{ item.devicecode }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <data-list
                  :width="500"
                  :header="popupHeaders"
                  :data="item"
                  dense
                >
                </data-list>
                <v-divider></v-divider>
                <v-card-actions class="px-2" dense>
                  <v-btn
                    @click="showStreetView(item)"
                    fab
                    x-small
                    dark
                    color="primary"
                    title="Street View"
                    ><v-icon color="#0c203d"
                      >mdi-google-street-view</v-icon
                    ></v-btn
                  >
                  <v-btn
                    @click="showDirections(item)"
                    fab
                    x-small
                    dark
                    color="primary"
                    title="Directions"
                    ><v-icon color="#0c203d">
                      mdi-directions</v-icon
                    ></v-btn
                  >
                  <v-btn
                    @click="showDetailData(item)"
                    fab
                    x-small
                    dark
                    color="primary"
                    ><v-icon color="#0c203d">
                      mdi-view-list-outline</v-icon
                    ></v-btn
                  >
                  <v-btn
                    @click="showDetailPhoto(item)"
                    fab
                    x-small
                    dark
                    color="primary"
                    ><v-icon color="#0c203d"> mdi-image-album</v-icon></v-btn
                  >
                </v-card-actions>
              </v-card>
            </l-popup>
          </l-marker>
        </template>
      </v-marker-cluster>
    </l-map>
    <v-dialog max-width="600" v-model="detailDialog">
      <v-card>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>{{ detailData.name }}</v-list-item-title>
            <v-list-item-subtitle
              style="
                font-size: 0.85rem;
                color: rgba(200, 255, 255, 0.8);
                margin-top: 2px;
                line-height: 1.4;
                font-weight: 400;
              "
              >{{ detailData.devicecode }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <data-list
          :width="500"
          :header="detailHeaders"
          :data="detailData"
          dense
          list-class=""
          list-item-class=""
        >
        </data-list>
        <v-card-actions dense>
          <v-btn
            outlined
            color="#00ffff"
            class="btn-outline"
            @click="detailDialog = false"
            ><span style="color: #00ffff">Close</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="800" v-model="photoDialog">
      <v-card>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>{{ detailData.name }}</v-list-item-title>
            <v-list-item-subtitle
              style="
                font-size: 0.85rem;
                color: rgba(200, 255, 255, 0.8);
                margin-top: 2px;
                line-height: 1.4;
                font-weight: 400;
              "
              >{{ detailData.devicecode }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-row v-if="dialogMode == 'list'">
            <v-col
              v-for="(item, n) in photographList"
              :key="n"
              class="d-flex child-flex pa-2"
              cols="4"
            >
              <v-img
                :src="`${baseUrl}/spju/imagefile/${detailData.devicecode}/${item}?token=${token}`"
                aspect-ratio="1"
                class="#102242"
                @click="clickImage(item)"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="#102242"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
          <v-row v-if="dialogMode == 'image'">
            <v-col>
              <v-img
                :src="`${baseUrl}/spju/imagefile/${detailData.devicecode}/${currentImage}?token=${token}`"
                class="#102242"
                contain
                @click="clickImage2(item)"
              >
              </v-img>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions dense>
          <v-btn
            outlined
            color="#00ffff"
            class="btn-outline"
            @click="photoDialog = false"
            ><span style="color: #00ffff">Close</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="600" v-model="imageDialog">
      <v-card> TEST </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
// <l-popup :options="{closeButton: false}">
//    <v-card
//      elevation="0"
//      width="400"
//    >
//      <v-card-text class="px-0 pt-2" >
//        {{item}}
//      </v-card-text>
//      <v-card-actions class="px-0" dense>
//        <v-btn @click="dialog=true" icon><v-icon>mdi-google-street-view</v-icon></v-btn>
//      </v-card-actions>
//    </v-card>

// </l-popup>

// <l-marker v-for="(item, i) in markers" :key="i" :lat-lng="[item.latitude, item.longitude]"></l-marker>
// import L from 'leaflet';
// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
// latitude: "-6.9711250203062205"
// longitude: "107.69027352333069"
// <iframe src="https://www.google.com/maps/embed?pb=!4v1657382379258!6m8!1m7!1s9hA1muoPss8UmB4W0_QtTg!2m2!1d-6.919314040460276!2d107.572033599354!3f170.15004!4f0!5f0.7820865974627469" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControl,
  LControlZoom,
} from "vue2-leaflet";
import L, { icon, divIcon } from "leaflet";
import icon_img from "@/assets/markers/map-marker.svg";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import DataList from "./DataList";
import store from "@/store";

// <iframe width="600" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=2880%20Broadway,%20New%20York&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LControlZoom,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    LPopup,
    DataList,
  },
  data: () => ({
    dialog: false,
    detailDialog: false,
    photoDialog: false,
    imageDialog: false,
    dialogMode: "list",
    detailData: {},
    streetLongitude: 107.69,
    streetLatitude: -6.971,
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '© <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    // zoom: 15,
    // center: [51.505, -0.159],
    // markerLatLng: [51.504, -0.159],
    // markers: [{name: 'test', longitude: 107.63134002685547, latitude: -6.946066024567296}],
    clusterOptions: {
      maxClusterRadius: 20,
        /**
         * Fungsi ini akan dipanggil oleh leaflet-markercluster setiap kali
         * ia perlu menggambar ikon cluster. Kita memaksanya untuk
         * selalu menggunakan CSS class 'marker-cluster-custom-green'.
         */
      iconCreateFunction: function (cluster) {
        var childCount = cluster.getChildCount();
        
        // Selalu gunakan class 'marker-cluster-custom-green'
        var c = ' marker-cluster-custom-green'; 
        
        return new L.DivIcon({
          html: '<div><span>' + childCount + '</span></div>',
          className: 'marker-cluster' + c,
          iconSize: new L.Point(40, 40)
        });
      }
    },
    icon: icon({
      iconUrl: icon_img,
      iconSize: [32, 37],
      iconAnchor: [16, 33],
    }),
    iconSize: 64,
    mapMode: "status",
    // defaultMapIcon: '<i class="v-icon notranslate mdi mdi-target theme--light blue--text"></i>',

    showMore: false,
    rolename: "admin",
    greetingMessage: "Hello...",

    // title: 'judul'
  }),
  // https://pju.antares.id/stview-dist/index.html?longitude=undefined&latitude=-6.94402120264601
  methods: {
    getFirstNotNull(vpositions) {
      if (vpositions.length > 0) {
        for (let i = 0; i < vpositions.length; i++) {
          let vpos = vpositions[i];
          if (vpos.latitude && vpos.longitude) {
            return vpos;
          }
        }
      }
      return null;
    },

    doClick() {
      this.dialog = true;
      // alert('test')
    },
    showStreetView(vitem) {
      const url = `https://www.google.com/maps?q=${vitem.latitude},${vitem.longitude}&layer=c&cbll=${vitem.latitude},${vitem.longitude}`;
      window.open(url, "_blank");
    },
    showDirections(vitem) {
      const url = `https://www.google.com/maps/dir/?api=1&destination=${vitem.latitude},${vitem.longitude}`;
      window.open(url, "_blank");
    },
    zoomAll() {
      console.log("markerBounds", this.markerBounds);
      if (this.$refs["map-obj"] && this.$refs["map-obj"].mapObject) {
        try {
          this.$refs["map-obj"].mapObject.fitBounds(this.markerBounds, { padding: [30, 30] });
        } catch (e) {
          console.warn("fitBounds error:", e);
        }
      }
    },
    closeMapPopup() {
      console.log("refs-test", this.$refs);
      if (this.$refs["map-obj"] && this.$refs["map-obj"].mapObject) {
        this.$refs["map-obj"].mapObject.closePopup();
      }
    },
    showDetailData(vitem) {
      this.detailData = vitem;
      this.detailDialog = true;
    },
    async showDetailPhoto(vitem) {
      this.dialogMode = "list";
      this.detailData = vitem;
      if (vitem && vitem.devicecode) {
        await this.$store.dispatch("devices/getPhotographList", {
          devicecode: vitem.devicecode,
        });
      }
      this.photoDialog = true;
    },

    clickImage(imgsrc) {
      console.log("click-image", imgsrc);
      this.currentImage = imgsrc;
      this.dialogMode = "image";
      this.$forceUpdate();
      // this.imageDialog = true;
    },
    clickImage2() {
      this.dialogMode = "list";
      this.$forceUpdate();
      // this.imageDialog = true;
    },

    icondiv(itemData) {
      // let vhtml = this.defaultMapIcon;
      let vhtml = this.getMarkerHtml(this.mapMode, itemData).html;
      // let vmapMode = this.mapMode;
      // if (vmapMode === "status") {
      //    if (typeof itemData["status"] !== "undefined") {
      //      let vstatus = itemData["status"];
      //      vhtml = this.mapIcons[vmapMode]["other"]["html"];
      //      if (typeof this.mapIcons[vmapMode][vstatus] !== "undefined") {
      //        vhtml = this.mapIcons[vmapMode][vstatus]["html"];
      //      }
      //    }
      // }
      return divIcon({
        html: vhtml,
        // iconSize: [60, 62],
        iconSize: [38, 95],
        iconAnchor: [14, 28],
        popupAnchor: [0, -30],
        className: "myDivIcon",
      });
    },
    checkRole: function () {
      return true;
    },
    clickHandler() {},
    xgetLegendHtml(vitem) {
      console.log("vitem...", vitem);
      let vcolor = vitem.color;
      let vicon = vitem.icon;
      // return vcolor+' - '+vicon
      // return '<i style="font-size: 28px" class="v-icon notranslate mdi mdi-map-marker-off-outline theme--light grey--text text--darken-4"></i>'
      return `<i style="font-size: 28px" class="v-icon notranslate mdi ${vicon} theme--light ${vcolor}"></i>`;
      // return '<i style="font-size: 28px" class="v-icon notranslate mdi mdi-map-marker-off-outline theme--light grey--text text--darken-4"></i>'
    },
    getLegendHtml(vitem) {
      console.log("legend-html", vitem);
      // return 'XXX'
      // return vitem
      let vcolor = vitem.color;
      let vicon = vitem.icon;
      // return vcolor+' - '+vicon
      // return '<i style="font-size: 28px" class="v-icon notranslate mdi mdi-map-marker-off-outline theme--light grey--text text--darken-4"></i>'
      return `<i style="font-size: 28px" class="v-icon notranslate mdi ${vicon} theme--light ${vcolor}"></i>`;
    },
    getMarkerHtml(field, item) {
      console.log("getMarkerHtml", field, item);
      console.log("mapIcons", this.mapIcons);
      let html = this.defaultMapIcon;
      let caption = "Other";
      // let vclass = this.defaultMapIconClass;
      let xvalue = "unknown";
      if (typeof item !== "undefined" && typeof item[field] !== "undefined") {
        xvalue = item[field];
        if (typeof this.mapIcons[field] !== "undefined") {
          if (typeof this.mapIcons[field][xvalue] !== "undefined") {
            html = this.getLegendHtml(this.mapIcons[field][xvalue]);
            console.log("html", html);
            caption = this.mapIcons[field][xvalue]["caption"];
            // vclass = this.mapIcons[field][xvalue]["class"];
          } else {
            xvalue = "other";
            if (typeof this.mapIcons[field]["other"] !== "undefined") {
              html = this.getLegendHtml(this.mapIcons[field]["other"]);
              console.log("html", html);
              caption = this.mapIcons[field]["other"]["caption"];
              // vclass = this.mapIcons[field]["other"]["class"];
            }
          }
        } else {
          xvalue = "unknown";
        }
      }
      return {
        xvalue: xvalue,
        html: html,
        caption: caption,
      };
    },
  },
  computed: {
    token() {
      var vUserInfo = store.getters.USER_INFO;
      var vtoken = vUserInfo.token;
      return vtoken;
    },
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
    maxContentHeight() {
      // return 800
      return this.height - 56;
    },
    photographList() {
      let vitem = this.$store.getters["devices/photographList"];
      if (vitem && Object.keys(vitem).length) {
        return vitem;
      }
      return [];
    },
    baseUrl() {
      // 1. Coba baca dari variabel environment saat proses build
      let envHost = process.env.VUE_APP_API_URL;
      if (envHost && envHost !== "undefined") {
        return envHost;
      }

      // 2. Fallback cerdas berdasarkan lokasi host/browser jika env tidak disetel
      let xhost;
      var vhost = window.location.hostname;
      if (vhost === "localhost") {
        xhost = "http://localhost:8084"; // Port local dev default
      } else {
        // Otomatis menembak URL api.domain_anda.com
        xhost = window.location.protocol + "//api." + window.location.host;
      }
      return xhost;
    },

    markerBounds() {
      let vlatmin = null;
      let vlatmax = null;
      let vlonmin = null;
      let vlonmax = null;
      if (Array.isArray(this.markers)) {
        for (let i = 0; i < this.markers.length; i++) {
          let vmarker = this.markers[i];
          if (vmarker && vmarker.latitude && vmarker.longitude) {
            let lat = parseFloat(vmarker.latitude);
            let lon = parseFloat(vmarker.longitude);
            if (!isNaN(lat) && !isNaN(lon) && lat !== 0 && lon !== 0) {
              if (vlatmin === null) {
                vlatmin = lat;
                vlatmax = lat;
                vlonmin = lon;
                vlonmax = lon;
              } else {
                if (vlatmin > lat) vlatmin = lat;
                if (vlatmax < lat) vlatmax = lat;
                if (vlonmin > lon) vlonmin = lon;
                if (vlonmax < lon) vlonmax = lon;
              }
            }
          }
        }
      }
      if (vlatmin === null) {
        return [[-6.901461, 107.618551], [-6.901461, 107.618551]];
      }
      return [
        [vlatmin, vlonmin],
        [vlatmax, vlonmax],
      ];
    },
    mapCenter() {
      let result = [-6.901461, 107.618551];
      // console.log("mapCenter - markers: ", this.markers, this.markers.length);
      let vpoint = this.getFirstNotNull(this.markers);
      // console.log("mapCenter - vpoint: ", vpoint);
      if (vpoint) {
        result = [vpoint.latitude, vpoint.longitude];
      }
      // if (this.markers.length > 0) {
      //    let vpoint = this.markers[0];
      //    result = [vpoint.latitude, vpoint.longitude];
      // } else if (this.markers.length > 1) {
      //    let vpoint = this.markers[0];
      //    result = [vpoint.latitude, vpoint.longitude];
      // }
      // console.log("mapCenter - result: ", result);
      return result;
    },
    categoryShowDef() {
      return this.categories;
    },
    defaultMapIcon() {
      let result = `<i style="font-size: 28px" class="${this.defaultIconClass}"></i>`;
      return result;
    },
    defaultMapIconClass() {
      return this.defaultIconClass;
    },
    legends() {
      // looping item of this.MapiCons
      let xfield = this.mapMode;
      let xfields = this.mapIcons?.[xfield];
      let keys = Object.keys(xfields);
      // let keys = this.mapIcons?.status?.keys();
      let result = {};
      keys.forEach((key) => {
        let field = xfield;
        let item = { [field]: key };
        let { xvalue, html, caption } = this.getMarkerHtml(field, item);

        // Cek apakah item asli punya tipe 'cluster-legend'
        let originalItem = this.mapIcons?.[field]?.[key] || {};
        let itemType = originalItem.type;

        if (caption) {
          result[xvalue] = {
            html: html,
            caption: caption,
            type: itemType
            // class: vclass,
          };
        }
      });
      return result;
    },
    xlegends() {
      let result = {};
      let field = this.mapMode;
      for (let i = 0; i < this.markers.length; i++) {
        let item = this.markers[i];
        let { xvalue, html, caption } = this.getMarkerHtml(field, item);

        result[xvalue] = {
          html: html,
          caption: caption,
          // class: vclass,
        };
      }
      return result;
    },
  },
  created() {
    // let me = this
    console.log("map center", this.center);
  },
  mounted() {
    this.$nextTick(() => {
      this.zoomAll();
    });
  },
  watch: {
    markers: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.$nextTick(() => {
            this.zoomAll();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    height: {
      type: Number,
      default: 500,
    },
    zoom: {
      type: Number,
      default: 16,
    },
    center: {
      type: Array,
      default: function () {
        return [-6.901461, 107.618551];
      },
    },
    markers: {
      type: Array,
      default: function () {
        return [
          {
            name: "Test",
            latitude: -6.901461,
            longitude: 107.618551,
          },
        ];
      },
    },
    title: {
      type: String,
      default: "Map",
    },
    iconDefs: {
      type: Array,
      default: function () {
        return [
          {
            iconUrl: icon_img,
            iconSize: [32, 37],
            iconAnchor: [16, 37],
          },
        ];
      },
    },
    categories: {
      type: Array,
      default: function () {
        return [
          { value: "status", caption: "Status" },
          { value: "devicetype", caption: "Device Type" },
          { value: "rssi", caption: "RSSI" },
          { value: "province", caption: "Province" },
        ];
      },
    },
    defaultIconClass: {
      type: String,
      default: "v-icon notranslate mdi mdi-map-marker theme--light blue--text",
    },
    mapIcons: {
      type: Object,
      default: function () {
        return {};
      },
    },
    popupHeaders: {
      type: Array,
      default: function () {
        return [];
      },
    },
    detailHeaders: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
};
</script>
<style scoped>
.button-legend {
  background-color: red;
}

/* Style kustom untuk cluster (HIJAU) */
::v-deep .marker-cluster-custom-green {
  background-color: rgba(0, 200, 0, 0.6) !important;
}
::v-deep .marker-cluster-custom-green div {
  background-color: rgba(0, 255, 0, 0.6) !important;
  color: #000000 !important;
  font-weight: bold !important;
}
::v-deep .marker-cluster-custom-green::before {
  display: none !important; /* Menghilangkan shadow/border luar */
}

/* Style kustom untuk legenda cluster (HIJAU) */
.legend-cluster-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: rgba(0, 255, 0, 0.6) !important;  
  border: 2px solid rgba(0, 200, 0, 0.8) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 🔹 Wrapper utama */
.custom-toggle-group {
  display: flex;
  align-items: center;
  border: 2px solid #00ffff;
  border-radius: 14px;
  background: #0c203da1;
  background-color: #0c203da1 !important;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.2);
  transition: all 0.3s ease;
}

/* 🔹 Tombol di dalam toggle */
.custom-toggle-btn {
  text-transform: none;
  color: #00ffff !important;
  background-color: #0c203da1 !important;
  background: #0c203da1 !important;
  border-right: 1px solid rgba(0, 255, 255, 0.2) !important;
  border-radius: 0 !important;
  font-weight: 500;
  letter-spacing: 0.3px;
  transition: all 0.25s ease-in-out !important;
  padding: 6px 14px !important;
}

/* 🔹 Hover effect */
.custom-toggle-btn:hover {
  background-color: rgba(0, 255, 255, 0.1) !important;
  color: #00ffff !important;
}

/* 🔹 Tombol aktif */
.v-item--active.custom-toggle-btn {
  background-color: rgba(0, 255, 255, 0.7) !important; /* cyan transparan */
  color: #0c203d !important; /* teks jadi gelap */
  font-weight: 600;
  box-shadow: inset 0 0 6px rgba(0, 255, 255, 0.5);
  transform: scale(1.02);
}

/* 🔹 Hapus border kanan di tombol terakhir */
.custom-toggle-btn:last-child {
  border-right: none !important;
}

/* 🔹 Fokus via keyboard */
.custom-toggle-btn:focus-visible {
  outline: 2px solid #00ffff !important;
  outline-offset: -2px;
}

.custom-toggle-zoom {
  background-color: #0c203da1 !important;
  background: #0c203da1 !important;
  color: #00ffff !important;
  border: 2px solid #00ffff !important;
  border-radius: 10px !important;
  text-transform: none;
  font-weight: 500;
  padding: 6px 16px !important;
  transition: all 0.25s ease-in-out !important;
  box-shadow: none !important;
}

/* Hover */
.custom-toggle-zoom:hover {
  background-color: rgba(0, 255, 255, 0.506) !important;
  background: #0c203da1 !important;
  color: #00ffff !important;
}

/* Aktif (klik) */
.custom-toggle-zoom:active {
  background-color: rgba(0, 255, 255, 0.506) !important;
  color: #0c203dbf !important;
  box-shadow: 0 0 12px rgba(0, 255, 255, 0.5) inset !important;
  transform: scale(0.98);
}

/* Fokus via keyboard */
.custom-toggle-zoom:focus-visible {
  outline: 2px solid #00ffff !important;
  outline-offset: 2px;
}

/* 🌌 Tema neon cyan untuk MapCard.vue */
.v-card {
  background: rgba(15, 35, 70, 0.5) !important;
  border: 1px solid rgba(0, 234, 255, 0.2) !important;
  color: #00ffff !important;
  box-shadow: 0 0 12px rgba(0, 255, 255, 0.3);
  backdrop-filter: blur(6px);
}

.v-list-item-title,
.v-list-item-subtitle,
.v-list-item-content,
.v-card-text,
.v-card-actions {
  color: #00ffff !important;
}

.v-divider {
  border-color: rgba(0, 255, 255, 0.3) !important;
}

/* Tombol-tombol */
.v-btn {
  border-color: #00ffff !important;
  color: #00ffff !important;
  background: rgba(0, 255, 255, 0.1);
  transition: all 0.2s ease;
}

/* 🔹 Style umum untuk tombol zoom in/out Leaflet */
.leaflet-control-zoom-in,
.leaflet-control-zoom-out {
  background-color: #0c203da1 !important;
  border: 2px solid #00ffff !important;
  color: #00ffff !important;
  font-weight: 600;
  border-radius: 6px !important;
  width: 32px !important;
  height: 32px !important;
  line-height: 28px !important;
  text-align: center;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
}

/* 🔹 Hover efek */
.leaflet-control-zoom-in:hover,
.leaflet-control-zoom-out:hover {
  background-color: rgba(0, 255, 255, 0.15) !important;
  background: rgba(0, 255, 255, 0.15) !important;
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.4) !important;
  transform: translateY(-1px);
}

/* 🔹 Klik / aktif */
.leaflet-control-zoom-in:active,
.leaflet-control-zoom-out:active {
  background-color: rgba(0, 255, 255, 0.3) !important;
  color: #0c203d !important;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.6) inset !important;
  transform: scale(0.96);
}

/* 🔹 Pastikan ikon “+” dan “–” tetap terlihat jelas */
.leaflet-control-zoom-in::after,
.leaflet-control-zoom-out::after {
  color: inherit !important;
}

/* 🔹 Hilangkan shadow atau background putih default dari Leaflet */
.leaflet-control-zoom {
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
}

/* Legend di pojok kiri bawah */
.v-card .v-list {
  background: rgba(15, 35, 70, 0.7) !important;
  border-radius: 8px;
  border: 1px solid rgba(0, 255, 255, 0.3);
}

/* Popup style */
.leaflet-popup-content-wrapper {
  background: rgba(15, 35, 70, 0.9);
  border: 1px solid #00ffff;
  color: #00ffff;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 255, 255, 0.2);
}
.leaflet-popup-tip {
  background: rgba(15, 35, 70, 0.9);
}

/* Dialog (Street View, Detail, Photo) */
.v-dialog .v-card {
  background: rgba(15, 35, 70, 0.8) !important;
  border: 1px solid #00ffff !important;
  color: #00ffff !important;
  box-shadow: 0 0 15px rgba(0, 255, 255, 0.4);
  backdrop-filter: blur(8px);
}

/* Map background transparan */
.l-map,
.leaflet-container {
  background: transparent !important;
}

/* Hapus style cluster default (cyan) agar tidak konflik */
/*
.marker-cluster-small,
.marker-cluster-medium,
.marker-cluster-large {
  background-color: rgba(0, 255, 255, 0.2) !important;
  border: 2px solid #00ffff !important;
  color: #00ffff !important;
  text-shadow: none !important;
}
*/

/* Tooltip style */
.leaflet-tooltip {
  background: rgba(15, 35, 70, 0.8);
  border: 1px solid #00ffff;
  color: #00ffff;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.2);
}

/* BUTTONS */
.btn-outline {
  border: 1px solid #00ffff !important;
  color: #00ffff !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.btn-outline:hover {
  background-color: rgba(0, 255, 255, 0.1) !important;
}

.btn-filled {
  background-color: #00ffff !important;
  color: #1e1e2f !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.btn-filled:hover {
  background-color: #18ffff !important;
  transform: scale(1.03);
}

@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
